export const EDITOR_TOPBAR_DEFAULT_HEIGHT = 48;
